export default {
  FIXED:      'fixed',
  RESPONSIVE: 'responsive',
  ADAPTIVE:   'adaptive',
};
